import type { FC } from "react";
import { Alert, Box } from "@mui/material";
import {
  isInternalQventusUsername,
  isPatientEmbedProductionHost,
} from "../utils/patient-embed-environment";

interface ProductionBannerProps {
  username: string;
}

const ProductionBanner: FC<ProductionBannerProps> = ({ username }) => {
  return isPatientEmbedProductionHost() &&
    isInternalQventusUsername(username) ? (
    <Box sx={{ position: "sticky", top: 0 }}>
      <Alert
        severity="error"
        sx={{
          borderRadius: 0,
          justifyContent: "center",
          py: 0.5,
        }}
      >
        <strong>PRODUCTION ENVIRONMENT</strong> — You are accessing live patient
        data
      </Alert>
    </Box>
  ) : null;
};

export default ProductionBanner;
